import {useEffect, useState} from "react";
import axios from 'axios';
import {useDispatch} from "react-redux";
import {setError} from "../../../slices/error/ErrorSlice";

export default function TnvedSergio() {
    const dispatch = useDispatch();

    const[list, setList] = useState([]);

    useEffect(() => {
        getList();
    }, []);

    function getList() {
        axios.get('/api/tnved-sergio-list')
            .then(res => {
                setList(res.data);
            })
            .catch(e => {
                dispatch(setError(e.response.data));
            })
    }

    let rows = list.map(item =>
        <tr key={item.id}>
            <td>{item.id}</td>
            <td>{item.code}</td>
            <td>{item.nameRus}</td>
            <td>{item.nameEng}</td>
        </tr>
    )

    return (
        <>
            <h1>Новые товары</h1>

            <table className="table table-striped table-bordered">
                <thead>
                <tr>
                    <th scope="col" style={{width: 95}}>ID</th>
                    <th scope="col" style={{width: 150}}>Код</th>
                    <th scope="col">Наименование рус.</th>
                    <th scope="col">Наименование англ.</th>
                </tr>
                </thead>
                <tbody>
                    {rows}
                </tbody>
            </table>
        </>
    )
}